module.exports = __webpack_public_path__ + "static/media/ilbc6.5bab7246.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ilbc6.jpg
// module id = 5804
// module chunks = 0